import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../contexts/SupabaseAuthContext';
import { useLanguage } from '../contexts/LanguageContext';
import { AuthShell } from '../components/AuthShell';

export default function Signup() {
  const { signUp } = useAuth();
  const { language } = useLanguage();
  const navigate = useNavigate();
  const es = language === 'es';

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [alreadyExists, setAlreadyExists] = useState(false);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setAlreadyExists(false);

    if (password !== confirmPassword) {
      setError(es ? 'Las contraseñas no coinciden' : 'Passwords do not match');
      return;
    }
    if (password.length < 6) {
      setError(
        es
          ? 'La contraseña debe tener al menos 6 caracteres'
          : 'Password must be at least 6 characters'
      );
      return;
    }

    setLoading(true);
    try {
      await signUp(email.trim(), password);
      setSuccess(true);
    } catch (err) {
      if (err?.code === 'user_already_exists' || /already (registered|exists)/i.test(err?.message || '')) {
        setAlreadyExists(true);
      } else {
        setError(err.message || (es ? 'No se pudo crear la cuenta' : 'Could not create account'));
      }
    }
    setLoading(false);
  };

  if (success) {
    return (
      <AuthShell title={es ? '¡Cuenta creada!' : 'Account created!'}>
        <p className="fp-msg fp-msg--ok">
          {es
            ? 'Revisá tu email para confirmar tu cuenta, y después iniciá sesión.'
            : 'Check your email to confirm your account, then log in.'}
        </p>
        <button className="fp-btn fp-btn--lg fp-btn--block" onClick={() => navigate('/login')}>
          {es ? 'Ir a Iniciar Sesión' : 'Go to Log In'}
        </button>
      </AuthShell>
    );
  }

  return (
    <AuthShell title={es ? 'Crear Cuenta' : 'Create Account'} onSubmit={handleSubmit}>
      <input
        type="email"
        value={email}
        onChange={(e) => { setEmail(e.target.value); setAlreadyExists(false); }}
        placeholder="Email"
        className="fp-input"
        required
        autoFocus
      />
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder={es ? 'Contraseña' : 'Password'}
        className="fp-input"
        required
      />
      <input
        type="password"
        value={confirmPassword}
        onChange={(e) => setConfirmPassword(e.target.value)}
        placeholder={es ? 'Confirmar contraseña' : 'Confirm password'}
        className="fp-input"
        required
      />

      {error && <div className="fp-msg fp-msg--error">{error}</div>}

      {alreadyExists && (
        <div className="fp-msg fp-msg--warn" data-testid="signup-exists-msg">
          <div>
            {es
              ? 'Ya existe una cuenta con ese email. Iniciá sesión, o recuperá tu contraseña si no la recordás.'
              : 'An account with that email already exists. Log in, or reset your password if you do not remember it.'}
          </div>
          <button
            type="button"
            className="fp-btn fp-btn--sm fp-btn--violet"
            style={styles.existsButton}
            onClick={() => navigate('/login', { state: { email: email.trim() } })}
          >
            {es ? 'Ir a Iniciar Sesión' : 'Go to Log In'}
          </button>
        </div>
      )}

      <button type="submit" className="fp-btn fp-btn--gold fp-btn--lg fp-btn--block" disabled={loading}>
        {loading ? '...' : es ? 'Crear Cuenta' : 'Sign Up'}
      </button>

      <p style={styles.switchText}>
        {es ? '¿Ya tenés cuenta?' : 'Already have an account?'}{' '}
        <Link to="/login" style={styles.switchLink}>
          {es ? 'Iniciá sesión' : 'Log in'}
        </Link>
      </p>
    </AuthShell>
  );
}

const styles = {
  existsButton: {
    marginTop: '9px',
  },
  switchText: {
    fontSize: '13.5px',
    color: '#eadcff',
    textAlign: 'center',
    margin: 0,
  },
  switchLink: {
    color: '#ffd400',
    fontWeight: 900,
    textDecoration: 'none',
  },
};
